import { Store } from "react-notifications-component";

const useDeedToast = () => {
  const deedToast = (message, msgType, title = null) => {
    Store.addNotification({
      title: title,
      message: message,
      type: msgType || "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
  };

  return { deedToast };
};

export default useDeedToast;
